// Question definitions for the SCS "Subject Disposition" wizard.
//
// Mirrors scsDescriptionOfStudiesQuestions: `number` is the stable badge shown
// in the CSR-style index badge (page order, hardcoded), `text` is the fallback
// wording and `tooltip` holds the ticket INFORMATION/helper text (the endpoint
// returns wording only, no tooltip map).
//
// At runtime the wording is overridden by
// GET /clinical_summaries/safety_summary/questions, keyed by the same
// attribute the answer is stored under. `textKey` names the attribute to read
// that wording from when it differs from the local key.

export const SCS_SD_QUESTIONS = {
  qDispositionOtherStudies: {
    number: 1,
    required: true,
    text: "Do you have any additional studies to report?",
    tooltip:
      "These would be additional studies included in some GIDB Tables but not all.",
  },
  qDispositionGroupingName: {
    number: 2,
    required: true,
    text: "Name the other grouping you want to describe.",
  },
  qDispositionTable: {
    number: 3,
    text: "Select the table you need to discuss.",
  },
  qDispositionTreatments: {
    number: 4,
    text: "What is the treatment you want to report?",
  },
};

// Yes / No toggle answers for question 1.
export const SCS_SD_OTHER_STUDIES_OPTIONS = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];
